export default __webpack_public_path__ + "static/media/image-mockups.48d35b17.png";